export default function Reputation() {
  const reviews = [
    {
      name: '漫画迷小王',
      avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20studio%20background%2C%20headshot%20photography%2C%20warm%20natural%20lighting%2C%20professional%20quality&width=80&height=80&seq=avatar-user-01&orientation=squarish',
      rating: 5,
      comment: '用了很多漫画网站，尾巴漫画网的体验是最好的！加载快，画质清晰，而且分类很全。恋爱和奇幻类的韩漫资源特别丰富，每天都要刷一刷！',
      date: '2026-07-28',
    },
    {
      name: '韩漫资深读者',
      avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20woman%20portrait%2C%20gentle%20smile%2C%20casual%20outfit%2C%20clean%20simple%20background%2C%20headshot%20photography%2C%20soft%20natural%20light%2C%20professional%20quality&width=80&height=80&seq=avatar-user-02&orientation=squarish',
      rating: 5,
      comment: '追韩漫三年了，自从发现尾巴漫画网就没有换过。更新速度很快，翻译质量也很高。下拉式阅读设计真的很舒服，强烈推荐给所有韩漫爱好者！',
      date: '2026-07-25',
    },
    {
      name: '漫画新手小陈',
      avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20student%20portrait%2C%20bright%20smile%2C%20casual%20style%2C%20clean%20studio%20background%2C%20headshot%20photography%2C%20warm%20natural%20lighting%2C%20fresh%20youthful%20look&width=80&height=80&seq=avatar-user-03&orientation=squarish',
      rating: 4,
      comment: '朋友推荐的这个网站，本来是随便看看，结果一入坑就停不下来了！分类很清晰，找漫画很方便。就是希望能多一些已完结的作品推荐。',
      date: '2026-07-20',
    },
    {
      name: '二次元少女',
      avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20girl%20portrait%2C%20cute%20smile%2C%20casual%20fashion%2C%20clean%20simple%20background%2C%20headshot%20photography%2C%20soft%20warm%20lighting%2C%20natural%20look&width=80&height=80&seq=avatar-user-04&orientation=squarish',
      rating: 5,
      comment: '画质真的太棒了！而且没有删减内容，阅读体验满分。排行榜功能也很好用，跟着榜单看了好几部高分韩漫，每一部都很精彩！',
      date: '2026-07-18',
    },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="reputation-heading">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 id="reputation-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            读者口碑
          </h2>
          <p className="text-sm text-foreground-500">来自真实读者的评价，是我们前进的动力</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {reviews.map((review, index) => (
            <div key={index} className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-xs ${i < review.rating ? 'text-accent-500' : 'text-foreground-200'}`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="ml-auto text-xs text-foreground-400 whitespace-nowrap">{review.date}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{review.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}